<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="mt-2">
          <v-card-title style="color:#1f245b">Rekapitulasi {{devices.station}}-{{devices.location}}</v-card-title>
          <v-divider class="mx-2"></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="data"
                  :items-per-page="5"
                  :calculate-widths="true"
                  item-key="station"
                  class="elevation-1"
                  hide-default-footer
                  disable-sort
                >
                <template v-slot:[`item.station`]="{ item }">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title>{{item.station}}</v-list-item-title>
                      <v-list-item-subtitle>{{item.phoneNumber}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template v-slot:[`item.timeReport`]="{ item }">
                  {{updateTime(item.timeReport)}}
                </template>
                <template v-slot:[`item.quota`]="{ item }">
                  {{item.quota}} MB
                </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <v-row>
      <v-col>
        <v-card>
          
          <v-card-title class="my-n2" style="color:#1f245b"
          >Download Data {{devices.station}}-{{devices.location}}
          <v-spacer></v-spacer>
          <v-dialog
            ref="dialog"
            v-model="modal2"
            :return-value.sync="time"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-col cols="6">
              <v-text-field
                v-model="dateRangeText"
                label="Pick Date"
                prepend-icon="mdi-clock-time-four-outline"
                class="mt-6"
                readonly
                v-bind="attrs"
                v-on="on"
                
              ></v-text-field>
              </v-col>
            </template>
            <v-date-picker
              v-if="modal2"
              v-model="dates"
              full-width
              range
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="modal2 = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dialog.save(time);getData(devices.id)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
          </v-card-title>

          <!-- <v-card-text>
            <v-row>
            <v-col>
              <v-divider></v-divider>
            <Bar
              :chart-options="chartOptions"
              :chart-data="chartData"
              :height="200"
            />
            </v-col>
            </v-row>
          </v-card-text> -->

          <v-divider></v-divider>

          <v-card-actions>
            <download-csv
              class   = "btn btn-default"
              :data   = "historicalDetail"
              :name    = "csvTitle"
              separator-excel
              :labels  = "labelsCSV">
              <v-btn class="float-start mb-2" color="primary" text><v-icon left>mdi-download</v-icon>Download</v-btn>
            </download-csv>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import firebase from "firebase/app"
import { db }from "@/firebase/db.js"
import moment from 'moment'
// import { Bar } from 'vue-chartjs/legacy'

import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

  export default {
    name: 'DataPage',
    components: { 
      // Bar
    },

    data: () => ({
      headers: [
          {
            text: 'Stasiun',
            align: 'start',
            value: 'station',
          },
          { text: 'Lokasi', value: 'location' },
          { text: 'Curah Hujan (mm)', value: 'curah' },
          { text: 'Waktu', value: 'timeReport' },
          { text: 'Kuota', value: 'quota' },
          { text: 'Masa Aktif', value: 'tenggang' },
        ],
      historical:[],
      time:[],
      devices:{},
      data:[],
      loadingData: true,
      offset:0,
    
      chartData: {
        labels: [],
        datasets: [ { label: 'Curah',data: [],backgroundColor: '#3f51b5', } ],
      },
      chartOptions: {
        responsive: true
      },
      headersDetail: [
          {
            text: 'Tanggal',
            align: 'start',
            value: 'tanggal',
          },
          { text: 'Curah (mm)', value: 'curah' },
        ],
      historicalDetail: [],
      timeDialog: null,
      modal2: false,
      dates:['2022-07-27', '2022-07-29'],
      // loadingData: true,
      tab: null,
      items: [
        'Grafik', 'Tabel',
      ],
      labels:[],
      datasets:[],
      csvTitle:null,
      labelsCSV:{
        tanggal: 'Tanggal',
        curah: 'Curah Hujan (mm)'
      }
    }),
    async mounted () {
      let loader = this.$loading.show()
      let device=localStorage.getItem("device");
      if (device!=this.$route.params.mac) {
        this.$router.push('/login')
      }
      const date=new Date();
      const today = Date.now()/1000;
      this.dates=[moment.unix(today-604800).utcOffset(this.offset).format("YYYY-MM-DD"),moment.unix(today).utcOffset(this.offset).format("YYYY-MM-DD")],
      this.offset=date.getTimezoneOffset()/(-60)
      
      await db.collection('device').doc(this.$route.params.mac).get().then((doc) => {
        this.devices={id:doc.id, ...doc.data()}
      });

      db.collection('report').doc(this.$route.params.mac).onSnapshot((doc) => {
        this.historical=[]
        if (doc.exists) {
          this.historical.push({id:doc.id, curah:doc.data().rain, tenggang:doc.data().expire, quota: doc.data().kuota, timeReport: doc.data().time})
          this.historical[0].location=this.devices.location
          this.historical[0].station=this.devices.station
          this.historical[0].phoneNumber = this.devices.phoneNumber
          this.historical[0].macAddress = this.devices.macAddress
          this.data=this.historical
        }
        loader.hide()
      })

      this.getData(this.devices.id)
    },
    computed: {
      dateRangeText () {
        let dateRange=[]
        if (this.dates[0]>this.dates[1]) {
          dateRange[0]=this.dates[1]
          dateRange[1]=this.dates[0]
        } else {
          dateRange[0]=this.dates[0]
          dateRange[1]=this.dates[1]
        }
        return dateRange.join(' ~ ')
      },
    },
    methods: {
      updateTime (time) {
        return moment.unix(time).utcOffset(this.offset).format("HH:mm, DD MMM YYYY")
      },
      getData (id) {
        // this.loadingData= true
        if (this.dates[0]>this.dates[1]) {
          let temp=this.dates[0]
          this.dates[0]=this.dates[1]
          this.dates[1]=temp
        }
        this.csvTitle=`${this.devices.station}-${this.dates[0]}~${this.dates[1]}.csv`
        let start = (moment(this.dates[0], "YYYY-MM-DD").valueOf()/1000);
        let end = (moment(this.dates[1], "YYYY-MM-DD").valueOf()/1000 +86400);
        
        var reportRef = db.collection('report').doc(id).collection('rain')
        reportRef.orderBy("time","desc").where("time", ">=", start).where("time", "<=", end).onSnapshot((collectionSnapshot) => {
          let i=0
          this.historicalDetail=[]
          this.datasets =[]
          this.labels=[]
          collectionSnapshot.forEach((doc) => {
            
            this.historicalDetail.push({tanggal: moment.unix(doc.data().time).utcOffset(this.offset).format("DD MMM YYYY"), curah:doc.data().rain})
            this.labels[i] = moment.unix(doc.data().time).utcOffset(this.offset).format("DD MMM YYYY")
            this.datasets[i] = doc.data().rain
            i++
          });
          this.chartData =  {
            labels: this.labels,
            datasets: [ { label: 'Curah',data: this.datasets,backgroundColor: '#3f51b5', } ],
          }
          // this.loadingData=false
        })
      }
    },
  }
</script>
